import type { IconProps } from '@/types/general'

export const Search = (props: IconProps) => (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		className={props.className}
		width="19"
		height="19"
		viewBox="0 0 19 19"
		fill="none"
	>
		<path
			d="M7.25 0.895752C3.25482 0.895752 0 4.15057 0 8.14575C0 12.1409 3.25482 15.3958 7.25 15.3958C8.97818 15.3958 10.5669 14.7853 11.8145 13.7708L16.7197 18.676C16.7888 18.748 16.8716 18.8055 16.9632 18.8451C17.0548 18.8846 17.1534 18.9056 17.2532 18.9066C17.3529 18.9076 17.4519 18.8887 17.5443 18.851C17.6367 18.8132 17.7206 18.7575 17.7912 18.6869C17.8617 18.6164 17.9175 18.5324 17.9552 18.4401C17.9929 18.3477 18.0118 18.2487 18.0108 18.1489C18.0098 18.0491 17.9889 17.9506 17.9493 17.859C17.9097 17.7674 17.8523 17.6846 17.7803 17.6155L12.875 12.7102C13.8895 11.4626 14.5 9.87393 14.5 8.14575C14.5 4.15057 11.2452 0.895752 7.25 0.895752ZM7.25 2.39575C10.4345 2.39575 13 4.96123 13 8.14575C13 9.69706 12.3881 11.0986 11.3955 12.1311C11.3343 12.1761 11.2803 12.2301 11.2354 12.2913C10.2029 13.2839 8.80131 13.8958 7.25 13.8958C4.06548 13.8958 1.5 11.3303 1.5 8.14575C1.5 4.96123 4.06548 2.39575 7.25 2.39575Z"
			fill="currentColor"
		/>
	</svg>
)
